import React from 'react';

import { IUINotice } from '~/src/dash/api/console-api';
import { NoticeIcon } from '~/src/dash/components/icons/misc-icons';
import { Col, Cols, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface IProps {
  uiNotices: Array<IUINotice>;
  currentPath: string;
  styleOverride?: React.CSSProperties;
}

export const UINoticeTopbar = ({ uiNotices, styleOverride }: IProps) => {
  return (
    <div
      style={{
        width: '65%',
        height: 'auto',
        backgroundColor: '#FEFFF4',
        borderRadius: '2px',
        position: 'absolute',
        left: '50%',
        transform: 'translate(-50%, 0)',
        ...(styleOverride || {}),
      }}
    >
      <Cols
        style={{
          padding: '8px 10px',
          alignItems: 'start',
        }}
      >
        <Col
          style={{
            paddingTop: '3px',
            paddingRight: '2px',
          }}
        >
          <NoticeIcon
            color={publicaColors.veryDarkGray}
            style={{ marginRight: '2', marginLeft: '2' }}
          />
        </Col>
        <Col>
          {uiNotices?.map((uiNotice, idx) => (
            <Text
              key={uiNotice.ID}
              extraSmall
              style={{
                fontFamily: 'Roboto',
                marginBottom: idx === uiNotices.length - 1 ? 0 : '0.25em',
              }}
            >
              {uiNotice.Detail
                ? uiNotice.Description + ': ' + uiNotice.Detail
                : uiNotice.Description}
            </Text>
          ))}
        </Col>
      </Cols>
    </div>
  );
};
